"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.sort.js");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var useSortableData = function useSortableData(items) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0, _react.useState)(config),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sortConfig = _useState2[0],
      setSortConfig = _useState2[1];

  var sortedItems = (0, _react.useMemo)(function () {
    var sortableItems = (0, _toConsumableArray2.default)(items);

    if (sortConfig !== null) {
      sortableItems.sort(function (a, b) {
        var valueA = a[sortConfig.key];
        var valueB = b[sortConfig.key]; // if item is a components sort by value
        // else don't sort

        if (valueA && valueB && !(typeof valueA === 'number' || typeof valueA === 'string')) {
          var _valueA, _valueA$props, _valueB, _valueB$props;

          valueA = (_valueA = valueA) === null || _valueA === void 0 ? void 0 : (_valueA$props = _valueA.props) === null || _valueA$props === void 0 ? void 0 : _valueA$props.value;
          valueB = (_valueB = valueB) === null || _valueB === void 0 ? void 0 : (_valueB$props = _valueB.props) === null || _valueB$props === void 0 ? void 0 : _valueB$props.value;
          if (!(valueA && valueB)) return 0;
        }

        if (valueA < valueB) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }

        if (valueA > valueB) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }

        return 0;
      });
    }

    return sortableItems;
  }, [items, sortConfig]);

  var requestSort = function requestSort(key) {
    var direction = 'ascending';

    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    setSortConfig({
      key: key,
      direction: direction
    });
  };

  return {
    items: sortedItems,
    requestSort: requestSort,
    sortConfig: sortConfig
  };
};

var _default = useSortableData;
exports.default = _default;